import pluralize from "pluralize";
import { SelectPicker } from "rsuite";

interface Props {
  currentModule: any;
  currentKey: string;
  onSwitchModule: (module: any) => void;
  onSwitchKey: (key: string) => void;
  modulesMap: Map<string, { Module: any; SubitemSchema?: any }>;
  disabled?: boolean;
  setKeepOpen: (keepOpen: boolean) => void;
}

const ReferenceModuleSelect = ({
  currentModule,
  currentKey,
  onSwitchModule,
  onSwitchKey,
  modulesMap,
  disabled,
  setKeepOpen,
}: Props) => {
  if (modulesMap && modulesMap.size === 1) {
    const subitemSchema = modulesMap.get(currentKey)?.SubitemSchema;

    const name = subitemSchema
      ? `${currentModule?.Name} ${pluralize(subitemSchema?.Name)}`
      : currentModule?.Name;

    return (
      <div className="text-dark w-100 align-self-center h5 mb-0">{name}</div>
    );
  }

  return (
    <SelectPicker
      size="sm"
      value={currentKey}
      onChange={onChange}
      cleanable={false}
      style={{ width: "100%", paddingRight: 20 }}
      menuStyle={{ zIndex: 99999 }}
      disabled={disabled}
      onOpen={() => setKeepOpen(true)}
      onClose={() => setKeepOpen(false)}
      data={
        modulesMap?.size > 0
          ? Array.from(modulesMap).map((mapArr) => {
              const key = mapArr[0];
              const modObj = mapArr[1];

              const mod = modObj.Module;
              const subitemSchema = modObj?.SubitemSchema;

              let name = subitemSchema
                ? `${mod?.Name}'s ${subitemSchema?.Name}`
                : mod?.Name;

              return { label: name || "", value: key || "" };
            })
          : []
      }
    />
  );

  function onChange(modAPIName: string | null) {
    if (!modAPIName) return;
    const mapEntry = modulesMap.get(modAPIName);
    const newModule = mapEntry?.Module;

    if (!newModule) return;

    onSwitchKey(modAPIName);
    onSwitchModule(newModule);
  }
};

export default ReferenceModuleSelect;
